import { init } from '@rexlabs/theme-luna';
export { init };
